import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeAppButtonBlockSkeleton } from './TypeAppButtonBlock'
import type { TypeBaseComponentSkeleton } from './TypeBaseComponent'
import type { TypeButtonBlockSkeleton } from './TypeButtonBlock'
import type { TypeTextBlockSkeleton } from './TypeTextBlock'

export interface TypePanelHeroComponentFields {
  title: EntryFieldTypes.Symbol
  text: EntryFieldTypes.EntryLink<TypeTextBlockSkeleton>
  primaryButton?: EntryFieldTypes.EntryLink<TypeAppButtonBlockSkeleton | TypeButtonBlockSkeleton>
  secondaryButton?: EntryFieldTypes.EntryLink<TypeAppButtonBlockSkeleton | TypeButtonBlockSkeleton>
  linkButton?: EntryFieldTypes.EntryLink<TypeButtonBlockSkeleton>
  desktopImage: EntryFieldTypes.AssetLink
  mobileImage: EntryFieldTypes.AssetLink
  size: EntryFieldTypes.Symbol<'L' | 'M' | 'S'>
  backgroundColour: EntryFieldTypes.Symbol
  anchorTag?: EntryFieldTypes.Symbol
  base: EntryFieldTypes.EntryLink<TypeBaseComponentSkeleton>
}

export type TypePanelHeroComponentSkeleton = EntrySkeletonType<TypePanelHeroComponentFields, 'panelHeroComponent'>
export type TypePanelHeroComponent<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypePanelHeroComponentSkeleton,
  Modifiers,
  Locales
>

export function isTypePanelHeroComponent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypePanelHeroComponent<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'panelHeroComponent'
}
